import { render, staticRenderFns } from "./RenameDossierModal.vue?vue&type=template&id=832cb3a4&scoped=true"
import script from "./RenameDossierModal.vue?vue&type=script&lang=js"
export * from "./RenameDossierModal.vue?vue&type=script&lang=js"
import style0 from "./RenameDossierModal.vue?vue&type=style&index=0&id=832cb3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832cb3a4",
  null
  
)

export default component.exports